import type { SessionTrackingData } from 'src/types/tracking';

const saveToSessionStorage = <T>(key: string, value: T): void => {
  const stringValue = JSON.stringify(value);
  sessionStorage.setItem(key, stringValue);
};

const getFromSessionStorage = <T>(key: string): T | Record<string, never> => {
  const stringValue = sessionStorage.getItem(key);
  if (stringValue) {
    return JSON.parse(stringValue) as T;
  }
  return {};
};

export const STORAGE_KEY = 'CAJA_TRACKING';

export const saveTrackingData = (dataToStore: SessionTrackingData) => {
  const storedData = getFromSessionStorage<SessionTrackingData>(STORAGE_KEY);
  const newData = { ...storedData, ...dataToStore };
  saveToSessionStorage(STORAGE_KEY, newData);
};

export const retrieveTrackingData = () =>
  getFromSessionStorage<SessionTrackingData>(STORAGE_KEY);

export const resetTrackingStorage = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
